import { IDeleteReportAction, IDeleteReportParams } from './deleteReport.interface';
import { DeleteReportTypes } from './deleteReport.type';

export const deleteReport = (payload: IDeleteReportParams): IDeleteReportAction => ({
  type: DeleteReportTypes.DELETE_REPORT,
  payload,
});
